var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2246 2.2002H4.77512C3.35376 2.2002 2.2002 3.35376 2.2002 4.77512V20.2246C2.2002 21.646 3.35376 22.7996 4.77512 22.7996H20.2246C21.646 22.7996 22.7996 21.646 22.7996 20.2246V4.77512C22.7996 3.35376 21.646 2.2002 20.2246 2.2002ZM21.5121 20.2246C21.5121 20.9365 20.9367 21.5121 20.2246 21.5121H4.77512C4.06443 21.5121 3.48765 20.9365 3.48765 20.2246V4.77512C3.48765 4.06443 4.06443 3.48765 4.77512 3.48765H20.2246C20.9365 3.48765 21.5121 4.06443 21.5121 4.77512V20.2246Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeselected);
export default __webpack_public_path__ + "static/media/Deselected.6d32f26924e1cf1e7ce35e165116abe0.svg";
export { ForwardRef as ReactComponent };